
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93S1mPiOx_45PpMP5d9Mgk9Zj5XdTjjfx_0U922Q5wEzgNcMeta } from "/codebuild/output/src833585057/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasIEhZ7oyxV4NroP2AC3FOJV5EwFY87MWelO_V_vh78lIMeta } from "/codebuild/output/src833585057/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexCmuWl27miq49Mq1wm3y6xpGH2E47icSrFtiMCCpOlk0Meta } from "/codebuild/output/src833585057/src/ark/pages/blog/index.vue?macro=true";
import { default as temasuQbuDdcpFwYm65iYfDLrMcwakY_FMoSGSNs7tBPCopIMeta } from "/codebuild/output/src833585057/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisavWb0YToX4v7it_lQffjOyXbUJ4ASa5_kQ1Jmr_15DLQMeta } from "/codebuild/output/src833585057/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as morada1GYY83xnoF1NXARtdrECgbT0IBdOKJT9eq7u9kT_4541kMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantes_wFTx3_TAwxjzLBVkpK43FZ3NVMSZmlSr6_45CUUhlO24Meta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasHewZQl_3FTEQslTmnBQV8G1JCeEaijuT1RlCbc4y5rEMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casaNrzdJuVBFH4UeoK1d0I6CACUj7hOahPJI2saLKmLDYAMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoXMchyAqzQgTXKmJcwGGFs1Wq7aKDs3fgmDEnoCjpSngMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraPSiNaHLl3WXbzg_45fvH0ElfyLBbgbIMwCi_45cqW1naKUoMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contacto0yvmmTfmgxUatmdCS5Y9Gf5bMGuWQq5gqpOtCdJ8s40Meta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadazSoKMBOtcR_45wBBfP8mddTDoXo0Ru17IUwu_45mNVWc3PgMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simular7mcfSpiWjqVrAbSXIwLPy7BMvgecPn7VHVhbxEXrqr4Meta } from "/codebuild/output/src833585057/src/ark/pages/energia/simular.vue?macro=true";
import { default as internet7GxGmNhQdNVueYLwG4_45H30MqQ7Fl27RHsSB8lNAQV5UMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelqjM_3wUuJSHi_p6eGmfe5yRNFX3fvKLRGDwspHfG5P4Meta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacao7MUiraaIHDqwdGVVOHoCMXkGk9eERPT_5PNGbk1aB8MMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualaMDyarLaO2C0u_4aKsBXutINaOuMstt_lac_45fZ2gzp0Meta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoekHCiy9Pl8z4S_45igYadscTRhmjvQo2N5NxJiUsDiUEwMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simular2HOLbQRo5m6PlvphoLuC_jpzVa9JZ5fCIE5osQ3aYIkMeta } from "/codebuild/output/src833585057/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93_4lFzgBDTCYP4dYvD1sCrEqYjMKB7Fsin8THLT_qlD8Meta } from "/codebuild/output/src833585057/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93S65wRv8y_czhz_45WZxbcWAT6FC90iDHOnQku0pptCzioMeta } from "/codebuild/output/src833585057/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoOMr37QCMXix9VuSTZscfEV_45hDPcDlEZ5fQ7cig_3IAEMeta } from "/codebuild/output/src833585057/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidade6d38gvgFnh5faw8ci4unHQSjw6LutSOZkqg4wrnd0lsMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxakvPt3X3AhWJgKfAHcmzu24EJi76d0bViUxoCyNJnHgUMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contacto2z8Z0FDJCmOFMCFhtXDIZ_45DEp1OL6jkIZ46MYaz2sJ8Meta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoQU8mn20RxY2z9_452gaK3yxGq6aWP9cD4qPQA6CkLxINgMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeira0nEF_NTiRq3AA_45zR8ds0lS8gG10JsGUUE8RABegvbsYMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoc0Be4DTUR55o_45aohd4f9IbfMhMZc6fSC4u2saPjj5swMeta } from "/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularjy0vTFly96_45usLuvP4uMIYh9HcOvDfLAlIDsKsXfYccMeta } from "/codebuild/output/src833585057/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93xHgWWn_45L2FQT6pEYVynsdpFi43vaZsM4ZPq_45H7_M71EMeta } from "/codebuild/output/src833585057/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosFoQrnDNvdievkCIBOOmN_452BTnICyAcUSWXS6912YmW4Meta } from "/codebuild/output/src833585057/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexz4go_45z5IMHf0nvjkzSCkXP6CFeX2CbIlGk8dNKddlToMeta } from "/codebuild/output/src833585057/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93_XA3xWymxPys4olMFig89ILeHvAvpTUn6XBCFmsoqWgMeta } from "/codebuild/output/src833585057/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93V2lNzZ6MafI_45Y8ud3Ej_45_g17awsHAMXY__45HmvjxoXgYMeta } from "/codebuild/output/src833585057/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simular7mcfSpiWjqVrAbSXIwLPy7BMvgecPn7VHVhbxEXrqr4Meta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src833585057/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simular2HOLbQRo5m6PlvphoLuC_jpzVa9JZ5fCIE5osQ3aYIkMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src833585057/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularjy0vTFly96_45usLuvP4uMIYh9HcOvDfLAlIDsKsXfYccMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src833585057/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src833585057/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93xHgWWn_45L2FQT6pEYVynsdpFi43vaZsM4ZPq_45H7_M71EMeta || {},
    component: () => import("/codebuild/output/src833585057/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosFoQrnDNvdievkCIBOOmN_452BTnICyAcUSWXS6912YmW4Meta || {},
    component: () => import("/codebuild/output/src833585057/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src833585057/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93_XA3xWymxPys4olMFig89ILeHvAvpTUn6XBCFmsoqWgMeta || {},
    component: () => import("/codebuild/output/src833585057/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93V2lNzZ6MafI_45Y8ud3Ej_45_g17awsHAMXY__45HmvjxoXgYMeta || {},
    component: () => import("/codebuild/output/src833585057/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]